import { motion } from "framer-motion";

const MILESTONES = [
    { year: "2022", title: "Основаване на Konstantin", desc: "Стартираме с ясна идея: честен, прозрачен и ориентиран към клиента подход към покупката на автомобил." },
    { year: "2023", title: "Първи 200 успешни продажби", desc: "Утвърждаваме се сред клиентите чрез качество, доверие и индивидуално отношение." },
    { year: "2024", title: "Разширяване на инвентара", desc: "Включваме премиум марки и стартираме професионален внос от Европа." },
    { year: "2025", title: "500+ доволни клиенти", desc: "Откриваме обновен шоурум и пускаме комплексни услуги: лизинг, регистрация, застраховки, детайлинг." },
    { year: "2026", title: "700+ успешно реализирани продажби", desc: "Продължаваме да следваме същите принципи, с които започнахме — прозрачност, коректност и качество." },
];

const ABOUT_IMG =
    "https://images.unsplash.com/photo-1580273916550-e323be2ae537?auto=format&fit=crop&w=1600&q=85";

export default function About() {
    return (
        <section id="about" className="relative py-28 lg:py-36" data-testid="about-section">
            <div className="max-w-7xl mx-auto px-6 lg:px-10">
                <div className="grid lg:grid-cols-12 gap-14 items-start">
                    <motion.div
                        initial={{ opacity: 0, x: -30 }}
                        whileInView={{ opacity: 1, x: 0 }}
                        viewport={{ once: true }}
                        transition={{ duration: 0.8 }}
                        className="lg:col-span-6 relative"
                    >
                        <div className="relative aspect-[4/5] overflow-hidden rounded-3xl">
                            <img
                                src={ABOUT_IMG}
                                alt="Konstantin showroom"
                                loading="lazy"
                                className="w-full h-full object-cover"
                            />
                            <div className="absolute inset-0 bg-gradient-to-t from-bg via-transparent to-transparent" />
                        </div>
                        <div className="absolute -bottom-6 -right-6 hidden md:block">
                            <div className="bg-bg border border-gold/30 rounded-2xl px-6 py-5 shadow-soft">
                                <div className="font-display text-3xl text-gold">700+</div>
                                <div className="text-[11px] uppercase tracking-[0.25em] text-ink-muted">
                                    Успешни продажби
                                </div>
                            </div>
                        </div>
                    </motion.div>

                    <div className="lg:col-span-6">
                        <motion.span
                            initial={{ opacity: 0, y: 12 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true }}
                            transition={{ duration: 0.6 }}
                            className="block text-gold text-[11px] uppercase tracking-[0.32em] mb-5"
                        >
                            За нас
                        </motion.span>
                        <motion.h2
                            initial={{ opacity: 0, y: 20 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true }}
                            transition={{ duration: 0.7 }}
                            className="font-display text-4xl sm:text-5xl lg:text-6xl tracking-tightest leading-[1.05] mb-8"
                        >
                            Преживяване, надминаващо <span className="text-gradient-gold">очакванията</span>
                        </motion.h2>
                        <motion.p
                            initial={{ opacity: 0 }}
                            whileInView={{ opacity: 1 }}
                            viewport={{ once: true }}
                            transition={{ duration: 0.8, delay: 0.2 }}
                            className="text-ink-muted leading-relaxed text-lg mb-12"
                        >
                            Преди повече от три години създадохме автокъща <span className="text-gold">Konstantin</span> с
                            ясната идея да предложим различен подход към покупката на автомобил —
                            честен, прозрачен и ориентиран към клиента. Днес, след над <span className="text-gold">700 успешно реализирани продажби</span>,
                            продължаваме да следваме същите принципи, с които започнахме.
                        </motion.p>

                        <ol className="relative border-l border-line ml-3 space-y-8" data-testid="about-timeline">
                            {MILESTONES.map((m, i) => (
                                <motion.li
                                    key={m.year}
                                    initial={{ opacity: 0, x: 20 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    viewport={{ once: true, margin: "-40px" }}
                                    transition={{ duration: 0.6, delay: i * 0.08 }}
                                    className="pl-8 relative"
                                >
                                    <span className="absolute -left-[7px] top-1.5 w-3 h-3 rounded-full bg-gold ring-4 ring-bg" />
                                    <div className="text-gold font-display text-xl">{m.year}</div>
                                    <div className="font-medium mt-1">{m.title}</div>
                                    <p className="text-ink-muted text-sm mt-1 leading-relaxed">
                                        {m.desc}
                                    </p>
                                </motion.li>
                            ))}
                        </ol>
                    </div>
                </div>
            </div>
        </section>
    );
}
